import { ThemeEvents } from '@theme/events';

/**
 * Quick Add Image
 * Updates the displayed image when the variant changes inside a quick-add dialog.
 *
 */
class QuickAddImage extends HTMLElement {
  #abortController = new AbortController();

  connectedCallback() {
    const dialog = this.closest('dialog');
    if (!dialog) return;
    dialog.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, {
      signal: this.#abortController.signal,
    });
  }

  disconnectedCallback() {
    this.#abortController.abort();
    this.#abortController = new AbortController();
  }

  /**
   * Called by quick-add.js after fetching section-rendering-quick-add on variant change.
   * @param {Document} html
   */
  updateFromHtml(html) {
    const source = html?.querySelector?.('quick-add-image');
    if (source) this.#swap(source);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    const html = event.detail?.data?.html;
    const source = html?.querySelector?.('quick-add-image');
    if (source) this.#swap(source);
  };

  /** @param {Element} source */
  #swap(source) {
    const currentImg = this.querySelector('img');
    const newImg = source.querySelector('img');
    if (!currentImg || !(newImg instanceof HTMLImageElement)) return;

    if (currentImg.src === newImg.src) return;

    currentImg.src = newImg.src;
    currentImg.srcset = newImg.srcset || '';
    currentImg.alt = newImg.alt || '';
    if (newImg.width) currentImg.width = newImg.width;
    if (newImg.height) currentImg.height = newImg.height;
  }
}

if (!customElements.get('quick-add-image')) {
  customElements.define('quick-add-image', QuickAddImage);
}
